<template>
  <card-block>
    <spinner-block v-model="dataProgress">
      <div v-if="data">
        <card-header>
          <template v-if="id">
            <router-link :to="{name: 'dictionary-place.detail', params: {id: id}}">Места одежды</router-link><!-- -->:
            редактирование

          </template>
          <template v-else>
            <router-link :to="{name: 'dictionary-place.list'}">Места</router-link><!-- -->:
            создание
          </template>


        </card-header>
        <card-body>
          <gui-checkbox v-model="data.is_active" :error="dataError.is_active" label="Активен"/>
          <gui-input v-model="data.name" :error="dataError.name" label="Название"/>
          <gui-input v-model="data.sort" :error="dataError.sort" label="Сортировка"/>

          <div class="mt-5">
            <button-save v-if="!data.id" @click="add()"/>
            <button-save v-else @click="save"/>
            <button-back/>
          </div>
        </card-body>
      </div>
    </spinner-block>
  </card-block>
</template>

<script>


export default {
  data() {
    return {
      data: null,
      dataDefault: {
        is_active: '',
        name: '',
        sort: 100,
      },
      dataError: {
        is_active: '',
        name: '',
        sort: '',
      },
      dataProgress: false,
    }
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  mounted() {
    this.init()
  },
  methods: {

    init() {
      if (this.id) {
        this.data = null
        this.loadData()
      } else {
        this.data = _.clone(this.dataDefault)
      }
    },
    loadData() {
      axiosGetValue('/api/admin/dictionary-place/get', {id: this.id}, e => this.data = e, e => this.dataProgress = e)
    },

    save() {
      axiosFast({
        url: route('/api/admin/dictionary-place/update'),
        data: {data: this.data, id: this.data.id},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: () => {
          toastSuccess('Данные сохранены');
          this.$router.push({name: 'dictionary-place.detail', params: {id: this.data.id}})
        },
      })
    },
    add() {
      axiosFast({
        url: route('/api/admin/dictionary-place/create'),
        data: {data: this.data},
        error: this.dataError,
        progress: e => this.dataProgress = e,
        result: (data) => {
          toastSuccess('Данные добавлены');
          this.$router.push({name: 'dictionary-place.detail', params: {id: data.id}})
        },
      })
    },
  },
}
</script>